










import { Component, Mixins } from "vue-property-decorator";

import TariffsTagsHelper from "@/mixins/TariffsTagsHelper";

import { EntityTypes } from "piramis-base-components/src/components/SelectEntityWizard/includes/types";
import Tags from "piramis-base-components/src/components/Tags/Tags.vue";

@Component({
  components: {
    Tags
  }
})
export default class TagBuy extends Mixins(TariffsTagsHelper) {
  onBuyLink(){
    this.$router.push({ name: 'buy', params: {
      [EntityTypes.CHAT_ID]: this.$store.state.chatState.chat.chat_id,
    }, })
  }
}

